import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { INFERENCE_STATUSES, InferenceStatus } from "constant";

import IconButton from "components/buttons/IconButton/IconButton";
import InferenceAction from "components/InferenceAction/InferenceAction";
import InferenceStatusComponent from "components/InferenceStatusComponent/InferenceStatusComponent";
import ShowHideButton from "components/buttons/ShowHideButton/ShowHideButton";
import CommonButton from "components/buttons/CommonButton/CommonButton";

import DragHandleDotsIcon from "assets/icons/drag-handle-dots.svg";
import TrashIcon from "assets/icons/trash.svg";
import MarkersFlagOffIcon from "assets/icons/markers-flag-off.svg";
import MarkersFlagOnIcon from "assets/icons/markers-flag.svg";
import FolderIcon from "assets/icons/folder-closed.png";

import styles from "./provider-folders-files-manager-modal.module.scss";

const SortableItem = ({
  item,
  id,
  alias,
  onUpdateVisibilityProvidersMarkers,
  inferenceDurationTime,
  uploadDurationTime,
  onDelete,
  onOpenFolder,
  onPrepareProvider
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id.toString() });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={styles["providers-table__body"]}
    >
      <div className={styles["drag-dots"]}>
        <img
          src={DragHandleDotsIcon}
          alt="drag-dots"
          {...attributes}
          {...listeners}
          style={{ cursor: "grab" }}
        />
        {/* <ShowHideButton
                                onClick={onUpdateVisibilityProvidersMarkers(
                                  item
                                )}
                                isActive={item.isActiveMarkers}
                                enabledIcon={EyeOpenGrayIcon}
                                disabledIcon={EyeCloseGrayIcon}
                              /> */}
        <ShowHideButton
          onClick={onUpdateVisibilityProvidersMarkers(item)}
          isActive={item.isActiveMarkers}
          enabledIcon={MarkersFlagOnIcon}
          disabledIcon={MarkersFlagOffIcon}
        />
      </div>
      <div className={styles["name"]}>{item.data.name}</div>
      <div className={styles["actions"]}>
        <CommonButton
          isSmall
          icon={FolderIcon}
          onClick={onOpenFolder(item.id)}
          disabled={item?.inference?.status === InferenceStatus.UPLOADING}
        >
          Open folder
        </CommonButton>
        <IconButton
          onClick={onDelete(item.id, !item?.inference?.status)}
          icon={TrashIcon}
          alt="trash-icon"
          disabled={item.isDeleteProviderLoading}
          isLoading={item.isDeleteProviderLoading}
        />
      </div>
      <div className={styles["name"]}>{uploadDurationTime(item.inference)}</div>

      {item?.inference?.status ? (
        <InferenceAction
          id={id}
          providerId={item.id}
          alias={alias}
          status={INFERENCE_STATUSES[item?.inference?.status]}
          isLoading={item.isInferenceStatusWaiting}
          disabled={item.isDeleteProviderLoading}
        />
      ) : (
        <div className={styles["name"]}>
          <CommonButton onClick={onPrepareProvider(item.id)}>
            Prepare to inference
          </CommonButton>
        </div>
      )}
      <div className={styles["name"]}>
        {inferenceDurationTime(item.inference)}
      </div>
      <InferenceStatusComponent
        status={INFERENCE_STATUSES[item?.inference?.status]}
        completionPercentage={
          item?.inference?.status === InferenceStatus.PROCESSING
            ? item?.inference?.data?.completion_percentage
            : item?.inference?.fileUploadData
            ? item?.inference?.fileUploadData.progress
            : undefined
        }
      />
    </div>
  );
};

export default SortableItem;
